<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
          v-model="title"
          label="需求概要"
          placeholder="请输入需求概要"
      />
      <van-field
        v-model="message"
        rows="5"
        autosize
        label="需求内容"
        type="textarea"
        placeholder="请输入需求内容"
      />
      <div style="margin: 16px">
        <van-button round block color="#FC6E09" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      title: "",
      message: ""
    };
  },
  methods: {
    onSubmit(values) {
      if (this.message && this.title) {
        let data={
          openid: localStorage.getItem("openid"),
          tips : this.message,
          title : this.title,
          nickname : localStorage.getItem("nickname")
        }
        this.$fetchPost(URL.addTips.url,data).then((res) => {
          if (res.data.code==20000) {
            this.$router.go(-1)
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.van-cell{
    margin-top: 10px;
}
</style>
